import { SafePromise } from '@benzinga/safe-await';

import { CoinData, CoinGeckoId, HowToBuyArticleData, PollData, VoteParams, VoteData } from './entities';
import { RestfulClient } from '@benzinga/session';
import { Session } from '@benzinga/session';
import { CryptoEnvironment } from './environment';

export class CryptoRestful extends RestfulClient {
  constructor(sessionManager: Session) {
    super(sessionManager.getEnvironment(CryptoEnvironment).url, sessionManager);
  }

  getCoin = (symbol: string): SafePromise<CoinData> => {
    const url = this.URL(`api/crypto/${symbol}`);
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin', timeout: 3000 });
  };

  getCoins = (symbols: string): SafePromise<CoinData[]> => {
    const url = this.URL(`api/crypto?symbols=${symbols}`);
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin', timeout: 3000 });
  };

  getHowToBuyArticle = (symbol: string): SafePromise<HowToBuyArticleData> => {
    const url = this.URL(`api/money/how-to-buy?tickers=CRYPTO:${symbol}`);
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin', timeout: 3000 });
  };

  getNumberOfVotes = (coinId: CoinGeckoId): SafePromise<PollData> => {
    const url = this.URL(`api/mob/poll?coin=${coinId}`);
    return this.get(url, { allowsAnonymousAuth: true, credentials: 'same-origin', timeout: 3000 });
  };

  postMOBVote = (postData: VoteParams): SafePromise<VoteData> => {
    const url = this.URL(`api/mob/vote`);
    return this.post(url, postData, { allowsAnonymousAuth: true, credentials: 'omit', timeout: 3000 });
  };
}
